<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col cols="12">
            <leave-pending-filter />
          </v-col>

          <v-col>
            <app-headline title="ผลการค้นหา" class="mb-2" />
            <leave-pending-table />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import LeavePendingFilter from '@/components/leave/LeavePending/LeavePendingFilter'
import LeavePendingTable from '@/components/leave/LeavePending/LeavePendingTable'

export default {
  components: {
    LeavePendingFilter,
    LeavePendingTable
  },

  data() {
    return {
      empInfo: {}
    }
  },

  computed: {
    title() {
      const txt = 'สถานะอนุญาตการลา '
      let name = ''

      if (this.$guid === this.$guid_self) {
        name = this.$username
      } else {
        name = this.empInfo[`employeeName${this.$lang}`] || ''
      }
      return txt + name
    }
  },

  async mounted() {
    if (this.$guid !== this.$guid_self) {
      this.empInfo = (await this.apiGetEmpName()) || {}
    }
  },

  methods: {
    async apiGetEmpName() {
      try {
        const res = await this.$store.dispatch('user/getInfo', this.$guid)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
